import type { ParsedRouterUrl } from './seo.types';

const CLASSIFIEDS_INDEXABLE_TYPES = new Set(['vehicle', 'property', 'pet', 'general']);

/** Split router URL into path + query (no hash). */
export function parseRouterUrl(url: string): ParsedRouterUrl {
  const noHash = (url || '/').split('#')[0];
  const [pathPart, queryString = ''] = noHash.split('?');
  let path = pathPart || '/';
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }
  return {
    path,
    queryString,
    query: new URLSearchParams(queryString),
  };
}

/** Query suffix preserved on /classifieds for SEO canonicals (e.g. ?type=vehicle). */
export function classifiedsCanonicalQuerySuffix(path: string, query: URLSearchParams): string {
  if (path !== '/classifieds') {
    return '';
  }
  const type = query.get('type');
  if (!type || !CLASSIFIEDS_INDEXABLE_TYPES.has(type)) {
    return '';
  }
  return `?type=${encodeURIComponent(type)}`;
}

/** Build absolute canonical URL for a route. */
export function buildCanonicalUrl(origin: string, path: string, query: URLSearchParams): string {
  const base = origin.replace(/\/$/, '');
  const suffix = classifiedsCanonicalQuerySuffix(path, query);
  const pathSegment = path === '/' ? '' : path;
  return `${base}${pathSegment}${suffix}`;
}

export function clipMetaDescription(text: string, max = 158): string {
  const normalized = (text || '').replace(/\s+/g, ' ').trim();
  if (normalized.length <= max) {
    return normalized;
  }
  return `${normalized.slice(0, max - 1).trim()}…`;
}
